import React from 'react';

const NotFound = () => (
  <div style={{ textAlign: 'center', marginTop: '50px' }}>
    <h1>404 - Página no encontrada</h1>
    <p>La ruta que buscas no existe o fue movida.</p>
    <a href="/">Volver al inicio</a>
  </div>
);

export default NotFound;